<mat-card class="av-card-info">
    <ng-content></ng-content>
</mat-card>
